// extracted by mini-css-extract-plugin
export default {"container":"FeedRow_container__AqaMx"};